module.exports = __webpack_public_path__ + "beac2ef54256c455dfbcb19414c4fa76.png";